export const getDisplayName = (event, t) => {
  if (event.translationKey) {
    return t(event.translationKey);
  }
  return event.displayName;
};
